import { SOCIAL_PROFILES, socialIconSvg } from '@brainfart/shared';

// Our accounts as a row of icons, each one a link: sits on its own line under the homepage footer. The accounts live in
// shared/src/social.ts (SOCIAL_PROFILES) and the icons in shared/src/social-icons.ts; the question pages use the same.
export function SocialLinks() {
  return (
    <nav aria-label="Our social accounts" style={{ maxWidth: 640, margin: '0.25rem auto 0', display: 'flex', justifyContent: 'center', gap: '0.25rem' }}>
      {SOCIAL_PROFILES.map(p => (
        <a
          key={p.key}
          className="text-link"
          href={p.url}
          target="_blank"
          rel="me noopener noreferrer"
          aria-label={`BrainFart.fun on ${p.name}`}
          title={p.name}
          style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44 }}
          dangerouslySetInnerHTML={{ __html: socialIconSvg(p.key, 22) }}
        />
      ))}
    </nav>
  );
}
